
  import {
    Component,
    Model,
    Prop,
    Vue,
    Watch
  } from "vue-property-decorator";
  import Dialog from '@/components/dialog.vue';
  import {
    getAgentProductSkuDetailList,
    getAgentProductSkuOrderList
  } from '@/api/order'

  @Component({
    name: 'sku-list-dialog',
    components: {
      'slz-dialog': Dialog,
    }
  })
  export default class SkuListDialog extends Vue {
    @Model('change') isShow!: boolean;
    @Prop({}) private id!: number;
    @Prop({}) private userId!: number;
    private showDialog = false;
    private list: any = []
    private showList = false;
    private orderlist: any = []


    @Watch('isShow')
    private onChangeShow(val) {
      this.showDialog = val
      if (val) {
        this.getList();
      }
    }

    // 关闭
    private handleClose() {
      this.showDialog = false;
      this.$emit('change', false)
    }

    private handleCloseList() {
      this.showList = false;
    }

    private async getList() {
      let params: any = {
        product_id: +this.id,
        check_user_id: this.userId,
      }
      try {
        const res: any = await getAgentProductSkuDetailList(params);
        this.list = res.info || [];
      } catch (e) {
        console.log(e)
      }
    }

    private async showOrderList(skuId: number) {
      this.showList = true;
      let params: any = {
        check_user_id: this.userId,
        product_id: this.id,
        sku_id: skuId
      }
      try {
        const res: any = await getAgentProductSkuOrderList(params);
        this.orderlist = res.info || []
      } catch (e) {
        console.log(e)
      }
    }
  }
